var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar" }, [
    _c("nav", { staticClass: "navbar is-transparent is-dark container" }, [
      _c("div", { staticClass: "navbar-brand menu-logo" }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            width: "auto",
            height: "auto",
            src:
              "" +
              (!_vm.isStatic
                ? _vm.logo
                : "../static/HSBC_MASTERBRAND_LOGO_RGB_NEG.png"),
            alt: _vm.alt,
            title: _vm.title
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "navbar-menu" }, [
        _c("div", { staticClass: "navbar-start" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navbar-end" },
          [
            _c("language-select", {
              staticClass: "navbar-item",
              attrs: { "dark-theme": true, "lang-root": "langSelector" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.linkingUser
        ? _c("div", { staticClass: "navbar-item" }, [
            _c(
              "div",
              {
                staticClass: "user has-text-right",
                attrs: { id: "headerUser" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "navbar-item",
                    attrs: { "data-ci": "user-profile" }
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.buyerName) +
                          "\n          "
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.linkingUser
        ? _c("div", { staticClass: "navbar-item", attrs: { id: "logout" } }, [
            _c("button", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "header.logoutBtn",
                  expression: "`header.logoutBtn`"
                }
              ],
              attrs: {
                type: "button",
                "data-ci": "logout-button",
                id: "logoutButton"
              },
              on: { click: _vm.logout }
            })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a337e7ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a337e7ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/Header.vue
// module id = 9iTY
// module chunks = 0 1 2